if (!customElements.get('bt-scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotion = this.querySelector('.bt-promotion');
      this.init();
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('bt-promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.setAttribute('aria-hidden', true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove('bt-scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('bt-scrolling-promotion--paused');
    }
  }

  customElements.define('bt-scrolling-promotion', ScrollingPromotion);
}
